export const parseCurrencyString = (value) => {
    if (!value)
        return '0';
    return value.replace(/[$,]/g, '');
};
export const getDecimalPlaces = (coinSymbol) => {
    const highPriceCoins = ['WBTC', 'WETH', 'LBTC', 'TBTC', 'XBTC', 'EBTC', 'SUIBTC', 'XAUM'];
    return highPriceCoins.includes(coinSymbol.toUpperCase()) ? 6 : 5;
};
